import {
  BookOpen,
  FileText,
  GitPullRequest,
  MessageSquare,
  Puzzle,
  Settings,
} from 'lucide-react';

const icons = {
  BookOpen,
  FileText,
  GitPullRequest,
  MessageSquare,
  Puzzle,
  Settings,
};

export default function Features({ content }) {
  return (
    <section className="section section-features" id="features">
      <div className="section-inner">
        <div className="section-header wide-header">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2>{content.title}</h2>
          <p>{content.intro}</p>
        </div>

        <div className="feature-grid">
          {content.groups.map((item) => {
            const Icon = icons[item.icon];
            return (
              <article className="feature-card" key={item.title}>
                <span className="card-icon">
                  <Icon size={21} />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
